import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';
import { AuthLayout } from '@/components/layout/auth-layout.js';
import { LoginForm } from '@/features/auth/login-form.js';
import { rootRoute } from './root.js';

function LoginPage(): JSX.Element {
  return (
    <AuthLayout title="Connexion">
      <LoginForm />
    </AuthLayout>
  );
}

/** `/connexion` — `02` §1. `redirect` porte l'URL protégée demandée avant la garde d'authentification. */
export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/connexion',
  validateSearch: (search: Record<string, unknown>): { redirect?: string | undefined } => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  component: LoginPage,
});
